export * from './CloseIcon';
export * from './HamburgerIcon';
export * from './ChevronIcon';
export * from './StarIcon';
export * from './RightArrowIcon';
export * from './LeftArrowIcon';
export * from './XIcon';
export * from './LinkedInIcon';
export * from './FacebookIcon';
export * from './LinkIcon';
export * from './CheckIcon';
export * from './DevsuWhiteIcon';
export { ArrowRightIcon } from './ArrowRightIcon';
export { default as PlayIcon } from './PlayIcon';
export { default as YouTubeIcon } from './YouTubeIcon';
//logos
export * from './logos/DevsuLogo';
